import { Input, Select } from "antd";
import {
  CaretDownFilled,
  CaretUpOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useMerchant } from "../../context/merchantContext";
import { useState } from "react";

const SearchMerchantNumber = ({
  title,
  fieldName,
  width = 200,
  noSearch = false,
  sort = true,
}) => {
  const { searchFieldsInvoice, setSearchFieldsInvoice, showFilter } =
    useMerchant();
  const [value, setValue] = useState(searchFieldsInvoice[fieldName]);
  const valueChange = (e) => {
    const currValue = e.target.value;
    setValue(currValue);
  };
  const startSearch = () => {
    setSearchFieldsInvoice((e) => {
      return { ...e, [fieldName]: value || null };
    });
  };

  const sortChange = (sort) => {
    setSearchFieldsInvoice({
      ...searchFieldsInvoice,
      sort: sort,
      sortField: fieldName,
    });
  };
  return (
    <div key={fieldName}>
      <div className="titleWithSort flex items-center justify-between">
        <span style={{ fontSize: 12 }}>{title}</span>
        {sort && (
          <div className="sortIcons">
            <CaretUpOutlined
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("asc")}
            />
            <CaretDownFilled
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("desc")}
            />
          </div>
        )}
      </div>
      {showFilter && (
        <>
          <div className="line" />
          {noSearch ? (
            <div style={{ height: 25 }} />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Input
                size="small"
                type="number"
                style={{ width: "80%" }}
                placeholder="Хайх утга"
                suffix={<SearchOutlined onClick={startSearch} />}
                value={value}
                onChange={valueChange}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default SearchMerchantNumber;
